import { ArrayBase } from '../ArrayBase';

export class State extends ArrayBase {}
